export default class dateHelper {
    public static geLibelleDateMoisAnnee(mois: number, annee: number): string {
        const moisEnLettres = new Date(annee, mois - 1, 1).toLocaleDateString("fr-FR", { month: "long" });

        return `${moisEnLettres.charAt(0).toUpperCase() + moisEnLettres.slice(1)} ${annee}`;
    }

    public static geLibelleDateMois(mois: number): string {
        const moisEnLettres = new Date(1, mois - 1, 1).toLocaleDateString("fr-FR", { month: "long" });

        return `${moisEnLettres.charAt(0).toUpperCase() + moisEnLettres.slice(1)}`;
    }
}



// WEBPACK FOOTER //
// ./src/Helper/dateHelper.ts